import { render, staticRenderFns } from "./TopEntityComponentAge.vue?vue&type=template&id=76b12380&"
import script from "./TopEntityComponentAge.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports